class car_packages {
  constructor() {
const WEBDOCCARINSDAILY1 = "WEBDOCCARINSDAILY1";
const WEBDOCCARINSDAILY2 = "WEBDOCCARINSDAILY2";
    this.items = [
      {
        serviceId: 1,
        pid: WEBDOCCARINSDAILY1,
        image: "assets/MiniAppAssets/car.png",
        name: "WebdocCarInsDaily1",
        serviceName:"Car Insurance",
        badge: "Silver",
        coverage: "200,000",
        price: "12",
        bgColorClass: "bg-info",
        description: `<p><strong>Car Insurance</strong> is an exciting product that provides good value to Jazz customers who get financial protection in case of Car Accidental damages.</p>
<ul>
<li><strong>Total Insurance Cover: </strong>PKR 200,000</li>
<li><strong>Accidental Car Repair: </strong>Up to PKR 100,000</li>
<li><strong>Accidental Hospitalization: </strong>Up to PKR 100,000</li>
<li><strong>Waiting Period: </strong> 30 days</li>
</ul>
<p><strong>Claims</strong></p>
<ul>
<li>Make your claim within 30 (thirty) days of the occurrence of accidental damage.</li>
<li>Settled directly with the claimants within 3 working days of document submission</li>
<li>Car registration documents should be in the name of subscribed customer</li>
</ul>`,
      },
      {
        serviceId: 2,
        pid: WEBDOCCARINSDAILY2,
        image: "assets/MiniAppAssets/car.png",
        name: "WebdocCarInsDaily2",
        serviceName:"Car Insurance",
        badge: "Gold",
        coverage: "400,000",
        price: "20",
        bgColorClass: "bg-warning",
        description: `<p><strong>Car Insurance</strong> is an exciting product that provides good value to Jazz customers who get financial protection in case of Car Accidental damages.</p>
<ul>
<li><strong>Total Insurance Cover: </strong>PKR 400,000</li>
<li><strong>Accidental Car Repair: </strong>Up to PKR 200,000</li>
<li><strong>Accidental Hospitalization: </strong>Up to PKR 200,000</li>
<li><strong>Waiting Period: </strong> 30 days</li>
</ul>
<p><strong>Claims</strong></p>
<ul>
<li>Make your claim within 30 (thirty) days of the occurrence of accidental damage.</li>
<li>Settled directly with the claimants within 3 working days of document submission</li>
<li>Car registration documents should be in the name of subscribed customer</li>
</ul>`,
        type: "rsa",
      },
    ];
  }

  getAllItems() {
    return this.items;
  }
}

export default car_packages;
